import React, { FC, useContext } from "react";
import { IonButton, IonButtons, IonIcon } from "@ionic/react";
import { parseISO, format } from "date-fns";

import { Context } from "../../store/student";
import { PulseSurveyQuestionWithAnswer } from "../../state";
import { replaceSearchTextAndUrl } from "../../libs/Convert";
import trashIcon from "../../assets/icons/trash.svg";
import editIcon from "../../assets/icons/edit.svg";

import styles from "./RealizationPulseSurvey.module.scss";

type Props = {
  state: {
    searching: boolean;
    searchText: string;
  };
  onEdit: (item: PulseSurveyQuestionWithAnswer) => void;
  onDelete: (item: PulseSurveyQuestionWithAnswer) => void;
};

const RealizationPulseSurvey: FC<Props> = ({ state, onEdit, onDelete }) => {
  const { contextState } = useContext(Context);

  const renderContent = (content: string) => ({
    dangerouslySetInnerHTML: {
      __html: replaceSearchTextAndUrl(content, state.searchText ?? ""),
    },
  });

  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {contextState.pulse_survey_questions_with_answers.map(question => {
          return (
            <li key={question.id} className={styles.item}>
              <div className={styles.inner}>
                <p
                  className={styles.title}
                  {...renderContent(`Q. ${question.content}`)}
                />
                <p className={styles.score}>
                  スコア {question.answer.pulse_survey_question_score ?? `なし`}
                </p>
                <div className={styles.textBlock}>
                  {question.answer.pulse_survey_question_reason && (
                    <p
                      className={styles.text}
                      {...renderContent(
                        question.answer.pulse_survey_question_reason,
                      )}
                    />
                  )}
                  {question.answer.tomorrow_plan && (
                    <p
                      className={styles.text}
                      {...renderContent(question.answer.tomorrow_plan)}
                    />
                  )}
                </div>
                <div className={styles.footer}>
                  <p className={styles.date}>
                    {format(
                      parseISO(question.answer.created_at),
                      "yyyy/MM/dd HH:mm",
                    )}
                  </p>
                  <IonButtons className={styles.actionButtons}>
                    <IonButton onClick={() => onEdit(question)}>
                      <IonIcon icon={editIcon} className={styles.editIcon} />
                    </IonButton>
                    <IonButton onClick={() => onDelete(question)}>
                      <IonIcon icon={trashIcon} className={styles.deleteIcon} />
                    </IonButton>
                  </IonButtons>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RealizationPulseSurvey;
